import { parseDate } from './dateUtils';
import { endWithExt } from './urlUtils';

export function fixEvent(e: any): void {

    e.created_time = parseDate(e.created_time);
    e.media = [];
    if (e.thumbnail_url) {
        e.media.push('thumb');
    }
    if (e.media_url) {
        if (endWithExt(e.media_url, '.mp4')) {
            e.media.push('full video');
        }
        if (endWithExt(e.media_url, '.m3u8')) {
            e.media.push('video stream');
        }
    }
    
}
